import React, { useState } from 'react';
import { TextInput, StyleSheet } from 'react-native';
import { MainColors } from '../../../constants/Colors';
import FontSizes from '../../../constants/FontSizes';

const AuthTextInput = (props) => {
    const [isFocused, setIsFocused] = useState(false);

    return (
        <TextInput
            style={[styles.textInput, isFocused ? styles.focusedInput : styles.unfocusedInput]}
            selectionColor={MainColors.primary}
            placeholder={props.placeholder}
            placeholderTextColor={MainColors.mediumGray}
            accessibilityLabel={props.accessibilityLabel}
            accessibilityHint={props.accessibilityHint}
            autoCompleteType={props.autoCompleteType}
            keyboardType={props.keyboardType}
            returnKeyType={props.returnKeyType}
            secureTextEntry={props.secureTextEntry}
            autoCapitalize="none"
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            value={props.value}
            onChangeText={props.onChangeText}
            onSubmitEditing={props.onSubmitEditing}
        />

    )
}

const styles = StyleSheet.create({
    textInput: {
        color: MainColors.darkGray,
        backgroundColor: 'white',
        borderWidth: 1,
        borderColor: MainColors.lightGray,
        height: 50,
        marginBottom: 20,
        paddingLeft: 20,
        fontSize: FontSizes.medium,
        borderRadius: 4
    },
    focusedInput: {
        borderColor: MainColors.primary,
        borderWidth: 2
    },
    unfocusedInput: {
        borderColor: MainColors.lightGray,
        borderWidth: 1,
    },
});

export default AuthTextInput;